import { api } from '../api';

export interface Reservation {
  id: string;
  name: string;
  startDate: string;
  endDate: string;
  roomId: string;
  roomName: string;
  tenantId: string;
  tenantName: string;
  userId: string;
  userName: string;
  createdAt: string;
  updatedAt: string;
  status?: 'PENDING' | 'CONFIRMED' | 'CANCELLED';
}

export interface CreateReservationData {
  name: string;
  start_date: string;
  end_date: string;
  room_id: string;
  tenant_id: string;
  user_id: string;
  status?: string
}

export interface UpdateReservationData extends Partial<CreateReservationData> {}

export interface AvailabilityResponse {
  room_id: string;
  room_name: string;
  request_date: string;
  initHour: string;
  endHour: string;
  available: boolean;
  is_reserved: boolean;
}

interface ListReservationsParams {
  page?: number;
  limit?: number;
  search?: string;
  tenant_id?: string;
  room_id?: string;
  start_date?: string;
  end_date?: string;
}

export const reservationService = {
  list: async (params?: ListReservationsParams) => {
    const queryParams = new URLSearchParams();
    
    if (params?.page) queryParams.append('page', params.page.toString());
    if (params?.limit) queryParams.append('limit', params.limit.toString());
    if (params?.search) queryParams.append('search', params.search);
    if (params?.tenant_id) queryParams.append('tenant_id', params.tenant_id);
    if (params?.room_id) queryParams.append('room_id', params.room_id);
    if (params?.start_date) queryParams.append('start_date', params.start_date);
    if (params?.end_date) queryParams.append('end_date', params.end_date);

    const response = await api.get(`/reservations?${queryParams.toString()}`);
    return response.data;
  },

  getById: async (id: string) => {
    const response = await api.get(`/reservations/${id}`);
    return response.data;
  },

  getByTenant: async (tenantId: string) => {
    const response = await api.get(`/reservations/tenant/${tenantId}`);
    return response.data;
  },

  checkAvailability: async (date: string, roomId: string) => {
    const response = await api.get(`/reservations/availability?date=${date}&room_id=${roomId}`);
    return response.data;
  },

  create: async (data: CreateReservationData) => {
    const response = await api.post('/reservations', data);
    return response.data;
  },

  update: async (id: string, data: UpdateReservationData) => {
    const response = await api.put(`/reservations/${id}`, data);
    return response.data;
  },

  delete: async (id: string) => {
    await api.delete(`/reservations/${id}`);
  },
};